/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { LoneIconButton } from '@blend/enterprise-components';
import { HelpModal } from './HelpModal';

export const styles = StyleSheet.create({
  clickable: {
    cursor: 'pointer',
  },
});

export namespace HelpAction {
  export interface Props {}
}

export const HelpAction: React.FC<HelpAction.Props> = ({}) => {
  const [isHelpOpen, setHelpOpen] = useState<boolean>(false);

  return (
    <>
      <div className={css(styles.clickable)}>
        <LoneIconButton
          btnSize="sm"
          icon="help_outline"
          iconSize={24}
          onClick={() => setHelpOpen(true)}
          theme="light"
        />
      </div>
      <HelpModal handleClose={() => setHelpOpen(false)} isOpen={isHelpOpen} />
    </>
  );
};
